/**
 * Env config model (structure of env.json)
 */
export class EnvConfig {
    /**
     * Environment name
     *
     * | Type of environment | json | Comment |
     * | --- | --- | --- |
     * | demo | demo.json |  |
     * | development | development.json |  |
     * | mock | mock.json | without authorization (for customer's demo) |
     * | production | production.json |  |
     * | qa | qa.json |  |
     * | sprint | sprint.json |  |
     * | stage | stage.json |  |
     */
    public env: string;

    /**
     * Build version shown in footer
     */
    public buildVersion: string;
}



// WEBPACK FOOTER //
// ./src/app/services/config/env-config.ts